import { store } from "../store";

export const getPractitionerById = id => {
  const practitioners = store.getState().practitioners || [];
  return practitioners.find(practitioner => practitioner.id === id);
};
